import { render, staticRenderFns } from "./LastWeek.vue?vue&type=template&id=287c2058&scoped=true&"
import script from "./LastWeek.vue?vue&type=script&lang=js&"
export * from "./LastWeek.vue?vue&type=script&lang=js&"
import style0 from "./LastWeek.vue?vue&type=style&index=0&id=287c2058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287c2058",
  null
  
)

export default component.exports